import { render, staticRenderFns } from "./services-popular.vue?vue&type=template&id=7b468f31&scoped=true"
import script from "./services-popular.vue?vue&type=script&lang=js"
export * from "./services-popular.vue?vue&type=script&lang=js"
import style0 from "./services-popular.vue?vue&type=style&index=0&id=7b468f31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b468f31",
  null
  
)

export default component.exports